import React from 'react';
import PropTypes from 'prop-types';
import staticPath from 'util/misc/static-assets-path';

export default function PaymentTwint({ title, text }) {
    return (
        <div className="cms-payment">
            <div className="cms-payment--title">{title}</div>
            <div className="cms-payment--body">
                <div className="cms-payment--images-list-wrapper">
                    <div className="cms-payment--images-list">
                        <img className="cms-payment--image" alt="visa" src={staticPath('img/logos/visa.svg')}/>
                        <img className="cms-payment--image" alt="mastercard" src={staticPath('img/logos/mastercard.svg')}/>
                    </div>
                </div>
                <div className="cms-payment--text" dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        </div>
    );
}

PaymentTwint.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/payment-twint/index.js